import { ApiError, useApiClient } from "@myplant-io/utils/api";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";
import { RagSource } from "../types";

type ModeWithFile = {
  _id: string;
  name: string;
  temperature: number;
  reasoning_effort?: string;
  no_innio_context: boolean;
  document_types: string[] | null;
  enabled_functions: string[] | null;
  system_prompt_addition: string;
  prompt_examples: string[];
  rag_sources: RagSource[];
};

export function useModeUpdate(
  options?: UseMutationOptions<unknown, ApiError, ModeWithFile>
) {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation(
    ({
      _id,
      name,
      temperature,
      reasoning_effort,
      no_innio_context,
      document_types,
      enabled_functions,
      system_prompt_addition,
      prompt_examples,
      rag_sources,
    }: ModeWithFile) => {
      return client.fetch(`/api/modes/${_id}`, {
        method: "PUT",
        body: JSON.stringify({
          name,
          temperature,
          reasoning_effort,
          no_innio_context,
          system_prompt_addition,
          document_types,
          enabled_functions,
          prompt_examples,
          rag_sources,
        }),
      });
    },
    {
      async onSettled() {
        await queryClient.invalidateQueries({
          queryKey: ["modes"],
        });
      },
      ...options,
    }
  );
}
